import React from "react";
import ReactMarkdown from "react-markdown";

const TextBodySection = ({ policyMarkdown = "" }) => {
  return (
    <section className="prt-row about-section01 clearfix">
      <div className="container">
        <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
          <div className="div-block-22">
            <ReactMarkdown>{policyMarkdown}</ReactMarkdown>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextBodySection;
